@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;
@use '../../styling/buttons.scss' as *;

$arrow-svg-gray: url('../../styling/svg/HiChevronDown.svg');

.PopoutButton {
  @extend %font-family-primary;
  @extend %button;

  color: $theme-color-text;
  background-color: $theme-color-background;
  border: 1px solid $theme-color-secondary-button-border !important;

  &:hover,
  &:active,
  &:focus {
    background: $theme-color-checkbox-disabled-checked-background;
    border-radius: 6px;
  }

  &.Small {
    height: 26px;
    min-width: max-content;
  }

  &.WithArrow {
    background-image:$arrow-svg-gray;
    background-repeat: no-repeat;
    background-position: right 5px top 50%, 0 0;
    background-size: 18px auto, 100%;
    justify-content: start;
    padding: 4px 28px 4px 8px;
  }
}
